import { render, staticRenderFns } from "./NoticeMailSetting.vue?vue&type=template&id=1b89b9b2&"
import script from "./NoticeMailSetting.vue?vue&type=script&lang=js&"
export * from "./NoticeMailSetting.vue?vue&type=script&lang=js&"
import style0 from "./NoticeMailSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VDivider,VProgressCircular,VSwitch})
